import { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

var MOOD_EMOJI = {
  'Grata(o)': '🙏', 'Em paz': '😌', 'Animada(o)': '✨', 'Empolgada(o)': '🌟',
  'Leve': '🌿', 'Esperançosa(o)': '🌅', 'Tranquila(o)': '🕊️',
  'Neutra(o)': '😶', 'Pensativa(o)': '🤔', 'Curiosa(o)': '🔍',
  'Ansiosa(o)': '💫', 'Cansada(o)': '😴', 'Sobrecarregada(o)': '🌊',
  'Triste': '🌧️', 'Confusa(o)': '🌀', 'Exausta(o)': '🌙',
};

export default function MoodColetivo() {
  var [mood, setMood] = useState(null);
  var [count, setCount] = useState(0);
  var [loading, setLoading] = useState(true);

  useEffect(function() {
    var today = new Date().toISOString().split('T')[0];
    supabase
      .from('daily_logs')
      .select('mood_word')
      .eq('date', today)
      .eq('completed', true)
      .not('mood_word', 'is', null)
      .then(function(res) {
        if (!res.data || res.data.length === 0) { setLoading(false); return; }
        // Contagem por mood_word
        var counts = {};
        res.data.forEach(function(row) {
          if (row.mood_word) counts[row.mood_word] = (counts[row.mood_word] || 0) + 1;
        });
        var top = Object.entries(counts).sort(function(a, b) { return b[1] - a[1]; })[0];
        if (top) { setMood(top[0]); setCount(top[1]); }
        setLoading(false);
      })
      .catch(function() { setLoading(false); });
  }, []);

  if (loading || !mood) return null;

  var emoji = MOOD_EMOJI[mood] || '💫';

  return (
    <div style={{
      background: 'var(--surface)', borderRadius: 'var(--r-lg)', border: '1px solid var(--border)',
      padding: '16px 18px', display: 'flex', alignItems: 'center', gap: 14,
      marginBottom: '28px',
    }}>
      <div style={{ fontSize: '2rem', flexShrink: 0, lineHeight: 1 }}>{emoji}</div>
      <div style={{ flex: 1 }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', color: 'var(--text-muted)', margin: '0 0 2px', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 500 }}>
          Clima do clube hoje
        </p>
        <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.05rem', fontWeight: 600, color: 'var(--primary)', margin: 0 }}>
          {mood}
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.78rem', fontWeight: 400, color: 'var(--text-muted)', marginLeft: 8 }}>
            · {count} {count === 1 ? 'pessoa' : 'pessoas'}
          </span>
        </p>
      </div>
    </div>
  );
}
